import type { ReactNode } from 'react';
import { useContext } from 'use-context-selector';
import { ContentSectionComponent } from '../contentSectionComponent/ContentSectionComponent';
import { NailArtLandingContext } from '../nailArtLandingProvider/NailArtLandingProvider';
import { NailArtLandingSections } from '../nailArtLandingSections/NailArtLandingSections';

type NailArtLandingContentProps = {
  hasFiltersApplied: boolean;
  nailArtGrid: ReactNode;
};

export const NailArtLandingContent = ({
  hasFiltersApplied,
  nailArtGrid,
}: NailArtLandingContentProps) => {
  const nailArtContext = useContext(NailArtLandingContext);

  if (nailArtContext === undefined) {
    throw new Error(
      'NailArtLandingContent must be used within a NailArtLandingContext'
    );
  }

  const { landingSections } = nailArtContext;

  const showLandingSections =
    landingSections && Boolean(landingSections?.length) && !hasFiltersApplied;

  return (
    <>
      {showLandingSections &&
        landingSections.map((section, index) => {
          return (
            <div
              key={`${section?.__typename}-${index}`}
              className="content-section"
            >
              <ContentSectionComponent section={section} />
            </div>
          );
        })}

      {!showLandingSections && nailArtGrid}

      <div>
        <NailArtLandingSections />
      </div>
    </>
  );
};
